/* requires:
polyfill.js
*/

// added to check visibility for fields that might contan "http"
const isElementVisible = (elem) => {
  return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
};

const actonLeadForm = {
  init: function (formSetting) {
    const { theForm } = formSetting;
    if (!theForm) {
      return false;
    }
    this.validateOnBlur(theForm);

    // listening for click on the submit button
    const submitBtn = theForm.querySelector('button[type=submit]') || theForm.querySelector('input[type=submit]');
    submitBtn.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        const isFormValid = actonLeadForm.isFormValid(theForm);
        if (!isFormValid) {
          theForm.querySelector('.validation-msg') && theForm.querySelector('.validation-msg').classList.remove('d-none');
          return false;
        } else {
          actonLeadForm.submit(formSetting);
        }
      },
      true
    );
  },
  validateOnBlur: function (theForm) {
    if (!theForm) {
      return false;
    }
    // realtime form fields validation using blur event
    const fields = theForm.querySelectorAll('.required');
    for (let field of fields) {
      const type = field.type;
      if (type === 'email') {
        field.addEventListener(
          'blur',
          function (e) {
            const x = field.value;
            const re =
              /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(x)) {
              field.classList.add('is-invalid');
            } else {
              field.classList.remove('is-invalid');
            }
          },
          true
        );
      } else if (type === 'tel') {
        field.addEventListener(
          'blur',
          function (e) {
            const x = field.value;
            const re = /[(]?\d{3}[)]?\s?-?\s?\d{3}\s?-?\s?\d{4}/;
            if (!re.test(x)) {
              field.classList.add('is-invalid');
            } else {
              field.classList.remove('is-invalid');
            }
          },
          true
        );
      } else if (type === 'checkbox' || type === 'radio') {
        field.addEventListener(
          'change',
          function (e) {
            const fieldName = field.name;
            const fieldValue =
              theForm.querySelector(`input[name='${fieldName}']:checked`) &&
              theForm.querySelector(`input[name='${fieldName}']:checked`).value;
            const fields = document.getElementsByName(fieldName);
            if (!fieldValue) {
              for (let field of fields) {
                field.closest('.custom-control').classList.add('is-invalid');
              }
              //isFormValid = false;
            } else {
              for (let field of fields) {
                field.closest('.custom-control').classList.remove('is-invalid');
              }
            }
          },
          true
        );
      } else {
        field.addEventListener(
          'blur',
          function (e) {
            const isFieldVisible = isElementVisible(field);
            // added http check so that bots and user cant submit with any http links
            const x = field.value;
            if (
              !x ||
              x.trim() == '' ||
              (isFieldVisible &&
                (x.toLowerCase().includes('http') || x.toLowerCase().includes('//') || x.toLowerCase().includes('www.')))
            ) {
              field.classList.add('is-invalid');
            } else {
              field.classList.remove('is-invalid');
            }
          },
          true
        );
      }
    }
  },
  isFormValid: function (theForm) {
    if (!theForm) {
      return false;
    }
    // form fields validation during submission
    const fields = theForm.querySelectorAll('.required');
    let isFormValid = true;
    for (let field of fields) {
      const type = field.type;
      if (type === 'email') {
        const x = field.value;
        const re =
          /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(x)) {
          field.classList.add('is-invalid');
          isFormValid = false;
        } else {
          field.classList.remove('is-invalid');
        }
      } else if (type === 'tel') {
        const x = field.value;
        const re = /[(]?\d{3}[)]?\s?-?\s?\d{3}\s?-?\s?\d{4}/;
        if (!re.test(x)) {
          field.classList.add('is-invalid');
          isFormValid = false;
        } else {
          field.classList.remove('is-invalid');
        }
      } else if (type === 'checkbox' || type === 'radio') {
        const fieldName = field.name;
        const fieldValue =
          theForm.querySelector(`input[name='${fieldName}']:checked`) &&
          theForm.querySelector(`input[name='${fieldName}']:checked`).value;
        const fields = document.getElementsByName(fieldName);
        if (!fieldValue) {
          for (let field of fields) {
            field.closest('.custom-control').classList.add('is-invalid');
          }
          isFormValid = false;
        } else {
          for (let field of fields) {
            field.closest('.custom-control').classList.remove('is-invalid');
          }
        }
      } else {
        const isFieldVisible = isElementVisible(field);
        const x = field.value;
        // added http check so that bots and user cant submit with any http links
        if (
          !x ||
          x.trim() == '' ||
          (isFieldVisible &&
            (x.toLowerCase().includes('http') || x.toLowerCase().includes('//') || x.toLowerCase().includes('www.')))
        ) {
          field.classList.add('is-invalid');
          isFormValid = false;
        } else {
          field.classList.remove('is-invalid');
        }
      }
    }
    return isFormValid;
  },
  submit: function (formSetting) {
    const { theForm, actonFormUrl } = formSetting;

    const oops = theForm.querySelector('input.oops').value;

    if (oops) {
      console.warn("You're a spam bot!");
      const resetFormFunction = Object.getPrototypeOf(theForm).reset;
      resetFormFunction.call(theForm);
    } else {
      theForm.action = actonFormUrl;

      // theForm.submit() doesn't work because we have name=submit in one of the input which override the submit() function on the form
      const submitFormFunction = Object.getPrototypeOf(theForm).submit;
      submitFormFunction.call(theForm);
    }
  },
};
